export enum DashboardCategoryEnum {
  Category1 = 'category_1',
  Category2 = 'category_2',
  Category3 = 'category_3',
  Category4 = 'category_4',
}

export enum DashboardVolumeType {
  Cut = 'cut',
  Fill = 'fill',
  Net = 'net',
}

export enum ProductivityDashboardFileType {
  Volume = 'volume',
  LeadDistance = 'lead_distance',
  VolumeAndLeadDistance = 'volume_and_lead_distance',
}

export const ProductivityDashboardFileTypeLabel: Record<
  ProductivityDashboardFileType,
  string
> = {
  [ProductivityDashboardFileType.Volume]: 'Volume',
  [ProductivityDashboardFileType.LeadDistance]: 'Lead Distance',
  [ProductivityDashboardFileType.VolumeAndLeadDistance]: 'Volume + Lead Distance',
};

export enum ProductivityFileOrder {
  Name = 'file_name',
  Format = 'format',
  Size = 'size',
  Type = 'type',
  AccountingPeriod = 'accounting_period_from',
  UploadedBy = 'uploaded_by',
  UploadedOn = 'uploaded_on',
}

export enum ProductivityFileDuplicateHandling {
  KeepBoth = 'keep_both',
  Replace = 'replace',
}
